import { connectionError } from '@guuru/chat-web';

export default function (value) {
  if (connectionError() !== value) connectionError(value);
}
